import { connect } from "react-redux";

// Constants
import { sections } from "src/constants";

// Component
import { CheckboxFilterComponent } from "src/components/filters";

// Selectors
import { lockStateFilterConfigSelector } from "src/selectors/ui_config_selectors/exports";
import { createSectionSelectors } from "src/ui_processors/global/selector_creators";

// Actions
import { createSectionActions } from "src/ui_processors/global/action_creators";

// State
function mapStateToProps(state) {
  return {
    filterConfig: lockStateFilterConfigSelector(state),
    filterCheckedState: createSectionSelectors(
      sections.exports
    ).createFilterCheckedStateSelector(lockStateFilterConfigSelector(state))(
      state
    )
  };
}

// Dispatch Actions
function mapDispatchToProps(dispatch) {
  return {
    selectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.exports).selectCheckbox(filterObject)
      );
    },
    deselectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.exports).deselectCheckbox(filterObject)
      );
    }
  };
}

export const WoundsEvaluationsLockStateFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxFilterComponent);
